export default "__VITE_ASSET__97cf43c8__"